import Base from './Base'
import styles from './FacetsSkeletonGroups.module.css'

export default function FacetsSkeletonGroups() {
  return (
    <div data-testid="facets-skeleton">
      <Group widths={[196, 186, 128]} />
      <Group widths={[158, 158, 144]} />
    </div>
  )
}

function Group({widths}: {widths: number[]}) {
  return (
    <div className={styles.group}>
      <Base className={styles.groupHeader} />
      <div className={styles.groupItems}>
        {widths.map((width, idx) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <Item key={idx} width={width} />
        ))}
      </div>
      <Base className={styles.groupDivider} />
    </div>
  )
}

function Item({width}: {width: number}) {
  return (
    <div className={styles.item}>
      <Base className={styles.itemIcon} />
      <Base className={styles.itemLabel} style={{maxWidth: width}} />
    </div>
  )
}
